import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';
import { NotFoundModule } from '@apps/gc-network/modules/error/not-found/not-found.module';
import { NetworkComponent } from '@apps/gc-network/modules/network.component';
import { TermsComponent } from '@apps/gc-network/modules/terms/terms.component';
import {
  IsAuthenticatedGuard,
  RedirectAtProfileGuard
} from '@lib/gc-common';

const routes: Routes = [
  {
    path: '404',
    loadChildren: () => NotFoundModule
  },
  {
    path: '',
    component: NetworkComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'trending',
      },
      {
        path: 'community-guidelines',
        component: TermsComponent,
        data: {
          metatags: {
            title: 'pages.metatag.community-guidelines.title',
          },
        },
      },
      {
        path: 'monetization-terms',
        component: TermsComponent,
        data: {
          metatags: {
            title: 'pages.metatag.monetization-terms.title',
          },
        },
      },
      {
        path: 'privacy',
        component: TermsComponent,
        data: {
          metatags: {
            title: 'pages.metatag.privacy.title',
          },
        },
      },
      {
        path: 'terms-of-service',
        component: TermsComponent,
        data: {
          metatags: {
            title: 'pages.metatag.terms-of-service.title',
          },
        },
      },
      {
        path: 'list-countries',
        component: TermsComponent,
        data: {
          metatags: {
            title: 'pages.metatag.list-countries.title',
          },
        },
      },
      {
        path: 'about-us',
        component: TermsComponent,
        data: {
          metatags: {
            title: 'pages.metatag.about-us.title',
          },
        },
      },
      {
        path: 'faq',
        loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'tutorials',
        loadChildren: () => import('./tutorials/tutorials.module').then((m) => m.TutorialsModule),
      },
      {
        path: 'emotional-health',
        loadChildren: () =>
          import('./emotional-health/emotional-health.module').then((m) => m.EmotionalHealthModule),
      },
      /*{
       path: 'influencers',
       loadChildren: () => import('./for-influencers/for-influencers.module').then(m => m.ForInfluencersModule)
       },*/
      /*{
       path: 'drawing',
       redirectTo: 'sweepstakes'
       },
       {
       path: 'sweepstake',
       redirectTo: 'sweepstakes'
       },
       {
       path: 'sweepstakes',
       loadChildren: () => import('./drawing/drawing.module').then(m => m.DrawingModule)
       },*/
      {
        path: 'hashtag-contest',
        loadChildren: () => import('./hashtag-contest/hashtag-contest.module').then((m) => m.HashtagContestModule),
      },
      {
        path: 'search',
        loadChildren: () => import('./search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'top-ranking',
        loadChildren: () => import('./top-ten-ranking/top-ten-ranking.module').then((m) => m.TopTenRankingModule),
      },
      {
        path: 'top-ten-ranking',
        redirectTo: 'top-ranking',
      },
      {
        path: 'hashtag',
        loadChildren: () => import('./hashtag/hashtag.module').then((m) => m.HashtagModule),
      },
      {
        path: 'audios',
        loadChildren: () => import('./audios/audios.module').then((m) => m.AudiosModule),
      },
      {
        path: 'trending',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'following',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
        canActivate: [IsAuthenticatedGuard],
      },
      {
        path: 'stories',
        loadChildren: () => import('./stories/stories.module').then((m) => m.StoriesModule),
      },
      {
        path: ':userId',
        loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
        canActivate: [RedirectAtProfileGuard],
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NetworkRoutingModule {
}
